import {useAuthUser} from '@igp/shared/auth';

export function useAgentId(): string {
    return (useAuthUser() as unknown as {playerId: string}).playerId;
}
